import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AMLCheckResult } from '../../Models/Domains/Customers/AMLCheckResult';

declare var IS_RUNNING_IN_APP_POOL;

export class AMLCheckClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(customerId: number, value: number): Promise<AMLCheckResult, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AMLCheck/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, value: value }

    return AjaxWrapper.post<AMLCheckResult, any>(url, data);
  }
}

